<template>
  <div class="subscribe-section-title">
    <slot />
  </div>
</template>

<!-- eslint-disable-next-line vue/enforce-style-attribute -->
<style lang="scss">
.subscribe-section-title {
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
</style>
